import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import richTextEditor from 'rich-text-editor-vuetify'
import './filters/filters'

Vue.config.productionTip = false

import "./styles/site.scss"

Vue.use(SweetModal);
Vue.use(am4themes_animated);
Vue.use(richTextEditor)

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
